/*
----------------------------
Module - search-header
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.searchForm = function(){

        var generateResults = fmg.fn.debounce(function () {

            // Prepare to make a call to funnelback for new results
            
            // Get query submitted
            var new_requested_query_string = $search_input.serialize();

            // Make a copy of the basic search url endpoint
            var new_requested_search_endpoint = base_search_endpoint;
            
            if (new_requested_query_string.length) {

                // Convert array into a string, joined by &, concatenate with source URL
                new_requested_search_endpoint = new_requested_search_endpoint + "&" + new_requested_query_string;
                
            }

            // Only ajax results if the next requested search is not the same as the previous one
            if (last_requested_search_endpoint !== new_requested_search_endpoint) {

                // When results are returned, replace everything
                $.get( new_requested_search_endpoint, function( data ) {

                    var $new_results = $(data).filter(search_results_wrapper_class);

                    if ($new_results.length) {

                        $search_results_inner_wrapper.html($new_results);
                        
                    }

                    // Update URL without reload so that users can press back to last filtered view
                    // First store just the pure URL without query string
                    var history_url = window.location.href.split('?')[0];

                    if (new_requested_query_string.length) {
                        history_url += "?" + new_requested_query_string;
                    }

                    window.history.replaceState("", "", history_url);

                    // Everytime there's new results, setup search filters again
                    // Must come after the new URL is set by window.history.replaceState as they depend on this
                    fmg.searchFiltering.init();

                    // Scroll back to top of results listing
                    $("html,body").animate({
                        scrollTop: $search_results_inner_wrapper.offset().top - 120
                    });

                });

                // Remember the last request
                last_requested_search_endpoint = new_requested_search_endpoint;
            
            }

        }, 700);

        function setupSearchForm() {

            // Enable search input field
            $search_input.prop("disabled", false);

            $search_form.on("submit", function(event) {

                event.preventDefault();

                var new_query = $search_input.val();

                if (new_query !== current_query) {
                    $search_input.trigger("blur");
                    generateResults();
                }

            });

        }

        function init() {

            $search_results_wrapper = $(".search-results");
            $search_form = $(".page-header__search-form");

            if ($search_results_wrapper.length && $search_form.length) {

                $search_results_inner_wrapper = $(search_results_inner_class);
                $search_input = $("#page-header__search-input");
                current_query = fmg.fn.sanitizeString(fmg.fn.getQueryParameter("query"));
                base_search_endpoint = $search_results_wrapper.data("search-endpoint");

                if (base_search_endpoint.length) {

                    // Only if .search-results__inner exists and theres a data-search-url then these filters can activate
                    setupSearchForm();

                }
                
            }
            
        }

        var $search_results_wrapper;
        var base_search_endpoint;
        var last_requested_search_endpoint;

        var current_query;
        
        var $search_form;
        var $search_input;
        
        var $search_results_inner_wrapper;
        var search_results_inner_class = ".search-results__inner";

        var search_results_wrapper_class = ".search-results__wrapper";
                
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.searchForm.init();
    });

}());
